(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["swatches"] && !Shopify.designMode) return;
  try {
    /* Colour dots on product cards (see the else branch below). */
  (() => {
    const selectedMedia = new WeakMap();

    const imageFor = (card, mediaId) =>
      card.querySelector(`slideshow-slide[slide-id="${mediaId}"] img`);

    /* Colour photos sit in hidden, lazy slides: fetch a card's colour photos when the finger or mouse
       reaches that card, instead of all of them at page load (about 1 MB saved on phones). */
    const preloadCard = (event) => {
      const card = event.target.closest && event.target.closest('product-card');
      if (!card || card.dataset.colorsPreloaded) return;
      card.dataset.colorsPreloaded = 'true';
      for (const dot of card.querySelectorAll('.brand-swatches__dot[data-media-id]')) {
        const img = imageFor(card, dot.dataset.mediaId);
        if (img) img.loading = 'eager';
      }
    };
    document.addEventListener('pointerover', preloadCard, { passive: true });
    document.addEventListener('touchstart', preloadCard, { passive: true, capture: true });

    /* Switch only once the photo is decoded, without the slide animation. */
    const showMedia = async (card, mediaId) => {
      const img = imageFor(card, mediaId);
      if (img) {
        img.loading = 'eager';
        await img.decode().catch(() => {});
      }
      if (selectedMedia.get(card) !== mediaId) return;
      card.querySelector('slideshow-component')?.select({ id: mediaId }, undefined, { animate: false });
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const dot = event.target.closest('.brand-swatches__dot');
      if (!dot) return;
      const card = dot.closest('product-card');
      if (!card) return;

      event.preventDefault();
      for (const other of card.querySelectorAll('.brand-swatches__dot')) {
        other.setAttribute('aria-pressed', String(other === dot));
      }
      if (dot.dataset.mediaId) {
        selectedMedia.set(card, dot.dataset.mediaId);
        showMedia(card, dot.dataset.mediaId);
      }
      if (dot.dataset.url) {
        for (const link of card.querySelectorAll('.product-card__link, [ref="cardGalleryLink"]')) {
          link.setAttribute('href', dot.dataset.url);
        }
      }
    });

    /* On hover the card previews its next photo, which can be another colour. Once a colour is
       chosen, keep that colour's photo. The theme catches these on document (capture), so stop
       them one step earlier, on window. */
    for (const type of ['pointerenter', 'pointerleave']) {
      window.addEventListener(
        type,
        (event) => {
          if (!(event.target instanceof Element) || !event.target.matches('.card-gallery')) return;
          const card = event.target.closest('product-card');
          if (card && selectedMedia.has(card)) event.stopPropagation();
        },
        true
      );
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
